// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {553: "b2c79130ed60498e",648: "1d5fc9da144b33e4",}[chunkId] + ".bundle.js"
}